<template>
  <div>
    <VContainer fluid>
    <VRow>
      <VCol cols="6">
        <VCard>
          <VToolbar>
            <VTabs v-model="tab">
              <VTab href="#tab-ja">日本語</VTab>
              <VTab href="#tab-en">English</VTab>          
            </VTabs>
          </VToolbar>
          <VTabsItems v-model="tab" class="ma-5">
            <VTabItem value="tab-ja" >
              <ArticleForm :articleParams="articleParams" lang="ja"></ArticleForm>
            </VTabItem>
            <VTabItem value="tab-en" >
              <ArticleForm :articleParams="articleParams" lang="en"></ArticleForm>
            </VTabItem>
          </VTabsItems>
        </VCard>
      </VCol>
      <VCol cols="6">
        <h3>プレビュー</h3>
        <div style="overflow-y: scroll; height: 73vh;">
          <ArticlePreview :articleParams="articleParams" :lang="tab.split('-')[1]" ></ArticlePreview>
        </div>
      </VCol>
    </VRow>
    <VRow dense>
      <VCol>
        <VBtn @click="submit">Submit</VBtn>
      </VCol>
      <VCol>
        <VBtn :to="{ name: 'ArticleShowPage', params: {id: $route.params.id} }" @click="submit" target="_blank">ページで開く</VBtn>
      </VCol>
    </VRow>
  </VContainer>
  </div>
  
</template>

<script>
import { HfMemberRegisterArticleCommandService } from "hfapi"
import Article from "@/aggregates/article"
import ArticleForm from "@@/components/organisms/articles/ArticleForm";
import ArticlePreview from "@@/components/organisms/articles/ArticlePreview";

export default {
  metaInfo() {
    return {
      title: `${this.article.title.ja}-記事編集ページ`,
    }
  },
  components: {
    ArticleForm,
    ArticlePreview,
  },
  data(){
    return {
      article: new Article(this.$route.params.id),
      articleParams: new HfMemberRegisterArticleCommandService.Params(),
      tab: "tab-ja"
    }
  },
  methods: {
    submit(){
      HfMemberRegisterArticleCommandService.execute(this.articleParams).then(resp=>{
          console.log(resp);
          this.flash("保存に成功しました", "success")
      }).catch(e=>{
        console.log(e.response.data);
        this.flash(e.response.data, "error")
      })
    },
  },
  mounted() {
    this.article.after_assign = ()=>{
      Object.assign(this.articleParams.article, this.article)
    }
  }
}
</script>

<style>

</style>